import { Link } from 'react-router-dom';
import { hotRanking, allArticles } from '@/mocks/articles';
import { useState, useMemo } from 'react';

export default function HotRanking() {
  const [startIndex, setStartIndex] = useState(0);
  const displayCount = 5;

  // Map hot ranking titles to actual article slugs for proper navigation
  const rankingWithSlugs = useMemo(() => {
    return hotRanking.map((item) => {
      const matched = allArticles.find((a) =>
        a.title.includes(item.title.substring(0, 8))
      );
      return {
        ...item,
        slug: matched?.slug || `article-${item.rank}`,
      };
    });
  }, []);

  const displayedItems = rankingWithSlugs.slice(startIndex, startIndex + displayCount);
  const canPrev = startIndex > 0;
  const canNext = startIndex + displayCount < rankingWithSlugs.length;

  return (
    <aside className="w-full lg:w-[340px] shrink-0">
      <div className="bg-background-50 rounded-xl p-6 sticky top-20">
        <h3 className="text-xl font-serif font-bold text-foreground-950 text-center mb-2">
          【 吃瓜热榜 】
        </h3>

        <div className="flex items-center justify-center gap-2 mb-5">
          <span className="inline-flex items-center gap-1 px-3 py-1 bg-foreground-900 text-background-50 text-xs font-semibold rounded-full">
            <i className="ri-fire-line text-accent-400"></i>
            实时热度
          </span>
        </div>

        <div className="space-y-4">
          {displayedItems.map((item) => (
            <Link
              key={item.rank}
              to={`/article/${item.slug}`}
              className="block"
            >
              <div className="flex items-start gap-3 group">
                <span
                  className={`shrink-0 w-6 h-6 flex items-center justify-center text-xs font-bold rounded-md ${
                    item.rank <= 3
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-200 text-foreground-600'
                  }`}
                >
                  {item.rank}
                </span>
                <div className="flex-1 min-w-0">
                  <p className="text-sm text-foreground-800 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </p>
                  <div className="flex items-center gap-2 mt-1">
                    <span className="text-xs text-foreground-500">
                      热度 {item.heat}
                    </span>
                    {item.change === 'up' && (
                      <i className="ri-arrow-up-line text-xs text-primary-500"></i>
                    )}
                    {item.change === 'down' && (
                      <i className="ri-arrow-down-line text-xs text-foreground-400"></i>
                    )}
                    {item.change === 'new' && (
                      <span className="text-xs text-accent-500 font-semibold">NEW</span>
                    )}
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="flex justify-end gap-1.5 mt-5">
          <button
            type="button"
            onClick={() => setStartIndex(Math.max(0, startIndex - 1))}
            disabled={!canPrev}
            className="w-8 h-8 flex items-center justify-center rounded-md border border-foreground-300 text-foreground-600 hover:bg-background-100 disabled:opacity-30 disabled:cursor-not-allowed cursor-pointer transition-colors"
          >
            <i className="ri-arrow-left-s-line text-sm"></i>
          </button>
          <button
            type="button"
            onClick={() => setStartIndex(Math.min(rankingWithSlugs.length - displayCount, startIndex + 1))}
            disabled={!canNext}
            className="w-8 h-8 flex items-center justify-center rounded-md bg-foreground-900 text-background-50 hover:bg-foreground-800 disabled:opacity-30 disabled:cursor-not-allowed cursor-pointer transition-colors"
          >
            <i className="ri-arrow-right-s-line text-sm"></i>
          </button>
        </div>
      </div>
    </aside>
  );
}